




































import { Component, Watch, Mixins, Inject } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { InnerMenu } from '@/pages/profile/blocks';
import Infotext from '@/components/parts/infotext';
import { OpenForm, Button } from '@/pages/profile/components';
import MentoringSuccess from '../../succss';
import { requestsRoutes } from '../../router';
import {
  LoaderMixin,
  StatusEnum,
  IsChildApprovedMixin,
} from '@/pages/profile/mixins';
import { mentoringService } from '@/services';
import { RoutsName, FormData, ChildDispatchModuleEnum } from './types';

@Component({
  components: {
    Infotext,
    InnerMenu,
    OpenForm,
    Button,
    MentoringSuccess,
  },
})
export default class MentoringRequests extends Mixins(
  LoaderMixin,
  IsChildApprovedMixin,
) {
  @Inject() $api: AxiosInstance;

  innerMenu = requestsRoutes;
  errorMessage: string = '';
  requests: Array<any> = [];
  tutoredIdFromRequest: string = '';
  successWarning: boolean = false;

  get notNewRequestRoute(): boolean {
    return this.$route.name !== RoutsName.NEW_REQUESTS;
  }

  get tutoredId(): string {
    return this.id ? this.childTutoredId(this.id) : '';
  }

  @Watch('id', { immediate: true })
  updateData() {
    this.reset();
    this.getData();
  }

  openForm(): void {
    this.$router.push({ name: RoutsName.NEW_REQUESTS });
  }

  reset() {
    this.requests = [];
    this.backToForm();
    this.closeMessages();
  }

  errorSetup(err: any) {
    if (err.response.data && err.response.data.errors) {
      const [{ msg }] = err.response.data.errors;
      this.errorMessage = msg;
    }
    this.status = StatusEnum.ERROR;
  }

  closeMessages() {
    this.errorMessage = '';
    this.tutoredIdFromRequest = '';
    this.status = StatusEnum.SUCCESS;
  }

  toAllRequest() {
    this.backToForm();
    this.$router.push({ name: 'profile-allrequests' });
  }

  backToForm() {
    this.successWarning = false;
  }

  async getData(): Promise<void> {
    const { $api, tutoredId, isLoading, tutoredIdFromRequest } = this;
    const id = tutoredId || tutoredIdFromRequest;

    if (!this.isApproved || !id) return;
    if (!isLoading) this.status = StatusEnum.LOADING;

    try {
      const { data } = await mentoringService($api).getRequest(id);
      this.requests = data;
      this.status = StatusEnum.SUCCESS;
    } catch (err) {
      this.errorSetup(err);
    }
  }

  async submitRequestForm(value: FormData): Promise<void> {
    const { id, $api, tutoredId } = this;
    if (!id || !Object.keys(value).length) return;
    this.status = StatusEnum.LOADING;

    try {
      await mentoringService($api).postRequest({ ...value, kid_id: id });
      if (!tutoredId) {
        const { tutored_id } = await this.$store.dispatch(
          ChildDispatchModuleEnum.DISPATCH_CHILD,
          id,
        );

        this.tutoredIdFromRequest = tutored_id ? tutored_id : '';
      }

      this.successWarning = true;
      this.getData();
    } catch (err) {
      this.errorSetup(err);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/requests/MentoringRequests.vue